<script>
  /**
   * Headline
   * @type {string}
   * @required
   */
  export let hed = 'Reuters Graphics Interactive';
  export let slugHed = '';

  /**
   * Array of author names, which will be slugified to create links to Reuters author pages
   */
  export let authors = [];
  /**
   * Publish time as a datetime string.
   * @type {string}
   */
  export let publishTime = '';
  /**
   * Update time as a datetime string.
   * @type {string}
   */
  export let updateTime = '';
  /**
   * Add an id to to target with custom CSS.
   * @type {string}
   */
  export let id = '';
  /**
   * Add extra classes to target with custom CSS.
   * @type {string}
   */
  export let cls = '';

  import { Byline } from '@reuters-graphics/graphics-components';
  import { apdate } from 'journalize';
  import { Block } from '@reuters-graphics/graphics-components';
  import CopyLink from './CopyLink.svelte';
  import slugify from '$utils/slugify';

  const isValidDate = (datetime) => {
    if (!datetime) return false;
    if (!Date.parse(datetime)) return false;
    return true;
  };

  const formatTime = (datetime) =>
    new Date(datetime).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
    });

  const areSameDay = (first, second) =>
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate();

  $: hedMain = hed.split(' ').slice(0, -1).join(' ');
  $: hedWidow = hed.split(' ').slice(-1).join(' ');
</script>

<Block {id} class="headline-container post-headline fmt-7 {cls}" width="normal">
  <header class="headline">
    <div class="dateline-container">
      {#if isValidDate(publishTime)}
        <div class="published-time font-bold whitespace-nowrap inline-block">
          <time class="uppercase" datetime={publishTime}>
            {#if isValidDate(updateTime)}
              {apdate(new Date(publishTime))}
            {:else}
              {apdate(new Date(publishTime))}&nbsp;&nbsp;{formatTime(
                publishTime
              )}
            {/if}
          </time>
        </div>
      {/if}
      {#if isValidDate(publishTime) && isValidDate(updateTime)}
        <div class="updated-time font-bold whitespace-nowrap block">
          <span>Updated</span>
          <time class="uppercase" datetime={updateTime}>
            {#if areSameDay(new Date(publishTime), new Date(updateTime))}
              {formatTime(updateTime)}
            {:else}
              {apdate(new Date(updateTime))}&nbsp;&nbsp;{formatTime(updateTime)}
            {/if}
          </time>
        </div>
      {/if}
    </div>
    <div class="title">
      {#if hed}
        <h2>
          <a href="#{slugify(slugHed)}">
            {hedMain}
            <span
              >{hedWidow}
              <CopyLink hed={slugHed} publishedDate={publishTime} /></span
            >
          </a>
        </h2>
      {/if}
    </div>
    <Byline {authors} />
  </header>
</Block>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  .dateline-container {
    @include mixins.body-caption;
    @include mixins.fmy-0;
    text-align: left;
    color: var(--theme-colour-accent);

    @media (min-width: mixins.$column-width-narrow) {
      .updated-time {
        display: inline-block;
        &:before {
          content: '·';
          margin: 0 5px 0 3px;
        }
      }
    }
  }

  h2 {
    @include mixins.fmy-1;
    @include mixins.font-black;

    a {
      color: inherit;
      text-decoration: none;
    }

    span {
      white-space: nowrap;
      display: inline-flex;
      align-items: baseline;
    }
  }
</style>
